// extracted by mini-css-extract-plugin
export default {"btn":"VIPButton_btn__jKvcZ","btnText":"VIPButton_btnText__YMwnE"};